import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { navigate, StaticQuery, graphql } from 'gatsby';
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { rgba } from 'polished';

import whiteArrowDown from '../assets/images/arrow-down-white.svg';
import blueDarkArrowDown from '../assets/images/arrow-down-blueDark.svg';
import { getLanguageCode } from '../utils';

const defaultLocale = 'en-us';

const LocaleSelect = styled.select`
  display: block;
  font-family: ${({ theme }) => theme.fontFamily.heading};
  color: ${({ theme, color }) => theme.colors[color]};
  font-size: ${({ theme }) => theme.spacing.baseUnit};
  outline: none;
  background-image: ${({ color }) => {
    switch (color) {
      case 'blueDark':
        return `url(${blueDarkArrowDown})`;
      default:
        return `url(${whiteArrowDown})`;
    }
  }};
  background-repeat: no-repeat;
  background-position: center right;
  background-color: transparent;
  border: 0;
  appearance: none;
  padding: ${({ theme }) => theme.spacing.baseUnit};
  margin-right: ${({ theme }) => theme.spacing.baseUnit};
  width: 100px;

  ${breakpoint('tablet')`
    margin-right: 0;
    font-size: ${({ theme }) => theme.spacing.baseDown1};
  `};
`;
const Option = styled.option`
  background-color: ${({ theme }) => rgba(theme.colors.black, 0.3)};
`;

class LocaleSelector extends Component {
  onChangeLocale = (e) => {
    const locale = e.target.value;
    const { location, selectedLocale } = this.props;
    // Split the current pathname by / and remove all empty strings
    const locationParts = location.pathname.split('/').filter(Boolean);

    // Will be used to hold new location parts
    let newLocationParts = [];

    if (locationParts.indexOf(getLanguageCode(selectedLocale)) !== -1) {
      /*
        Decide if the selected locale is in the pathname and if so (and
        we're not looking at the defalut locale), put the new locale at
        the start of the array, and fill with anything after first index.
        Otherwise, i.e. locale is the default one, remove anything after
        the first index, whitout a locale before.
      */
      newLocationParts =
        locale !== defaultLocale
          ? [getLanguageCode(locale), ...locationParts.slice(1)]
          : [...locationParts.slice(1)];
    } else {
      /*
        If the current pathname doesn't contain a locale, i.e. it's the
        english site, put the locale at the first index of the
        newLocationParts array.
        Otherwise, just return the locationParts array.
      */
      newLocationParts =
        locale !== defaultLocale
          ? [getLanguageCode(locale), ...locationParts]
          : [...locationParts];
    }

    navigate(`/${newLocationParts.join('/')}`);
  };

  render() {
    const { selectedLocale, optionColor } = this.props;

    return (
      <StaticQuery
        query={graphql`
          query {
            prismicLocaleSelector {
              data {
                locales {
                  name {
                    text
                  }
                  value
                }
              }
            }
          }
        `}
        render={({
          prismicLocaleSelector: {
            data: { locales },
          },
        }) => {
          const selectedLocaleObject = locales.find(
            (locale) => locale.value === selectedLocale,
          );

          return locales.length > 1 ? (
            <LocaleSelect
              onChange={this.onChangeLocale}
              value={selectedLocaleObject?.value}
              color={optionColor}
            >
              {locales.map((locale) => (
                <Option
                  key={`locale-option-${locale.value}`}
                  value={locale.value}
                >
                  {locale.name.text}
                </Option>
              ))}
            </LocaleSelect>
          ) : null;
        }}
      />
    );
  }
}

LocaleSelector.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  selectedLocale: PropTypes.string.isRequired,
  optionColor: PropTypes.string.isRequired,
};

export default LocaleSelector;
